import { getBaseurl } from "@/utils/url-parse";
import { API } from "@akc/biz-api";

export const queryBonusByActId = async (params: { actId?: string; actCode?: string }) => {
  return API.get<any>({
    path: `${getBaseurl()}/api/spweb/yearEndBonus/queryPlatform`,
    body: params,
  });
};
export const queryRank = async (params: { actId: string }) => {
  return API.get<any>({
    path: `${getBaseurl()}/api/spweb/yearEndBonus/queryRank`,
    body: params,
  });
};

export const queryAvatar = async (count: number) => {
  return API.get<any>({
    path: `${getBaseurl()}/api/mshop/mshop-aggr-prod/outer/atmosphere/avatarUrl`,
    body: {
      count,
    },
  });
};

export const queryBrandActList = async () => {
  return API.get<any>({
    path: `${getBaseurl()}/api/spweb/yearEndBonus/queryBrandActList`,
  });
};
